package com.shadowings.gero.data.lessons.chapter6
import com.shadowings.gero.data.lessons.buildVocabContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_impariamo_pronomi_suffissi_1
import gero.composeapp.generated.resources.exp_content_impariamo_pronomi_suffissi_2
import gero.composeapp.generated.resources.exp_title_vocab_pronomi_suffissi_intro

fun getVocabPronomiSuffissiContent(words: List<Word>, languageCode: String): List<IExplanation> {
    return (buildVocabContent(
        lessonTitle = Res.string.exp_title_vocab_pronomi_suffissi_intro,
        lessonIntro = Res.string.exp_content_impariamo_pronomi_suffissi_1,
        wordIds = listOf("IO", "TU_M", "TU_F", "EGLI", "ELLA", "ESSO", "NOI", "VOI", "ESSI"),
        words = words,
        languageCode = languageCode
    ) + ExplanationContent(
        title = Res.string.exp_title_vocab_pronomi_suffissi_intro,
        content = Res.string.exp_content_impariamo_pronomi_suffissi_2,
        face = com.shadowings.gero.domain.model.Faces.Serious,
    )).mapIndexed { index, it ->
        val zeta = listOf(0, 1, 2, 4, 7, 10)
        if (zeta.contains(index)) {
            (it as ExplanationContent).copy(character = Characters.Zeta)
        } else {
            it
        }
    }
}

fun getVocabPronomiSuffissiQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode
    )
}
